export const defaultTwitterCardMeta = 'summary_large_image';
